/**
 * chat_widget/src/widget/ui/VehiclesList/index.tsx
 */

import type { Vehicle } from "../../types/VehicleTypes";
import { getPrice } from "../../utils/formatter";
import { boiteLang, energieLang } from "../../utils/formatterLang";

export function VehicleResults({
  results,
  msgIndex,
  lang,
  getVehicleDetails,
}: {
  results: Vehicle[];
  msgIndex: number;
  lang: string;
  getVehicleDetails: (carId: string) => void;
}) {
  const energieFormatted = energieLang(lang);
  const boiteFormatted = boiteLang(lang);

  return (
    <div className="vcw-results" aria-label="Résultats véhicules">
      <div className="vcw-results-track">
        {results.map((v, idx) => {
          const img =
            v.photos && v.photos[0] && v.photos[0].src
              ? String(v.photos[0].src)
              : "";
          const key = `${msgIndex}_${idx}`;
          return (
            <div
              className="vcw-vehicle-card"
              key={key}
              onClick={() => getVehicleDetails(v._id)}
            >
              <div className="vcw-vehicle-thumb" aria-hidden="true">
                {img ? (
                  <img className="vcw-vehicle-img" src={img} alt="" />
                ) : (
                  <div className="vcw-vehicle-img-placeholder" />
                )}
              </div>

              <div className="vcw-vehicle-meta">
                <div className="vcw-vehicle-title">
                  {[v.marque, v.modele].filter(Boolean).join(" ")}
                </div>
                <span className="vcw-vehicle-subtitle">{v.version}</span>
                <div className="vcw-vehicle-specs">
                  <span className="vcw-vehicle-spec">
                    ◦ {getPrice(v.prixttcaffiche)} €
                  </span>
                  <br />
                  <span className="vcw-vehicle-spec">◦ {v.anneemodele}</span>
                  <br />
                  <span className="vcw-vehicle-spec">
                    {" "}
                    ◦ {getPrice(v.kilometrage)} km
                  </span>
                  <br />
                  <span className="vcw-vehicle-spec">
                    ◦{" "}
                    {energieFormatted[
                      v.energie as keyof typeof energieFormatted
                    ] ?? v.energie}
                  </span>
                  <br />
                  <span className="vcw-vehicle-spec">
                    ◦{" "}
                    {boiteFormatted[
                      v.typeboite as keyof typeof boiteFormatted
                    ] ?? v.typeboite}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
